import { render, staticRenderFns } from "./CreateNoteModal.vue?vue&type=template&id=3d916d3e&"
import script from "./CreateNoteModal.vue?vue&type=script&lang=ts&"
export * from "./CreateNoteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports